<script setup>
const banner = await queryContent('/banner').findOne()
</script>

<template>
  <section class="main__header">
    <NuxtImg src="/img/other/header-banner.png"
             class="banner"
             alt="Баннер"
             format="webp"
             :quality="100"
    />
    <NuxtImg
      src="/img/other/header-banner-360.png"
      alt="Баннер"
      class="banner banner-mobile"
      format="webp"
    />
    <div class="main__header-wrapper">
      <div class="container">
        <div class="row">
          <div class="col-6">
            <div class="main__header-content">
              <div class="main__header-content-top">
                <span class="rounded">{{ banner.label }}</span>
                <span class="date">
                  {{ banner.date }}
                </span>
              </div>
              <h1>
                {{ banner.title }}
              </h1>
              <p>
                {{ banner.subtitle }}
              </p>
            </div>
            <div class="main__header-buttons">
              <a href="#reserve-section" class="btn btn-primary btn-arrow-light main__header-btn-registration">зарегистрироваться</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.main__header {
  position: relative;

  .banner {
    display: block;
    width: 100%;
    height: auto;
    max-height: 920px;
    object-fit: cover;

    @media (max-width: $large) {
      background-position: center;
      padding-bottom: 0;
      min-height: 785px;
    }

    @media (max-width: $medium) {
      padding-bottom: 0;
      min-height: 560px;
    }
  }

  .banner-mobile {
    display: none;
  }

  &-wrapper {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .col-6 {
      @media (max-width: $medium) {
        width: 60%;
      }
    }
  }

  &-content {
    color: var(--dark-primary-color);
    padding: 0 25px 54px 71px;
    font-size: 22px;
    font-weight: 600;
    max-width: 690px;

    @media (max-width: $large) {
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 46px;
      font-size: 20px;
    }

    @media (max-width: $medium) {
      padding-bottom: 24px;
    }

    .rounded {
      @media (max-width: $large) {
        font-size: 19px;
      }
    }

    .btn {
      @media (max-width: $medium) {
        height: 52px;
        line-height: 48px;
      }
    }

    h1 {
      padding-bottom: 27px;
      color: var(--dark-primary-color);
      font-size: 52px;
      font-weight: 600;
      line-height: 1.2;
      letter-spacing: -0.8pt;

      @media (max-width: $large) {
        font-size: 46px;
      }

      @media (max-width: $medium) {
        font-size: 34px;
        padding-left: 15px;
        padding-bottom: 15px;
      }
    }

    p {
      color: var(--dark-primary-color);
      font-size: 23px;
      font-weight: 600;
      letter-spacing: 0.3pt;

      @media (max-width: $large) {
        font-size: 19px;
        padding-right: 20%;
      }

      @media (max-width: $medium) {
        padding-left: 15px;
      }
    }

    &-top {
      display: flex;
      gap: 30px;
      align-items: center;
      flex-flow: row nowrap;
      padding-bottom: 50px;

      @media (max-width: $large) {
        padding-bottom: 43px;
      }

      @media (max-width: $medium) {
        padding-bottom: 25px;
      }
    }
  }

  &-buttons {
    padding-left: 71px;

    @media (max-width: $large) {
      padding-left: 0;
    }
  }


  @media (max-width: $mobile) {
    display: flex;
    flex-flow: column-reverse;

    background: #c7cce9;
    background: radial-gradient(circle at 0 0, #749BFF 0.43%, #C8D4F8 25.17%, #E9F2FF 50%);

    &-wrapper {
      position: relative;
      padding-top: 100px;
      padding-bottom: 0;

      .col-6 {
        width: 100%;
      }
    }

    .banner {
      display: none;
    }

    .banner-mobile {
      display: block;
      width: 100%;
      height: auto;
      min-height: auto;
    }

    &-content {
      display: flex;
      flex-flow: column;
      align-items: center;
      padding-bottom: 55px;

      h3 {
        padding-left: 0;
        padding-bottom: 42px;
        text-align: center;
        font-size: 45px;
        max-width: 500px;
      }

      p {
        padding: 0;
        text-align: center;
        font-size: 24px;
        letter-spacing: 0;
        max-width: 500px;
      }
    }

    &-buttons {
      text-align: center;
    }
  }

  @media (max-width: $x-small) {
    &-wrapper {
      padding-top: 116px;
    }

    &-content {
      padding-bottom: 24px;

      h3 {
        padding-bottom: 20px;
        font-size: 28px;
        max-width: 300px;
      }

      p {
        font-size: 18px;
        max-width: 300px;
      }
    }
  }
}
</style>
